import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-462aabfe"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "van-cell cell-amount"
};
const _hoisted_2 = {
  class: "amount"
};

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("text", {
  class: "unit"
}, "元", -1));

const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 提现 ");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 交易明细 ");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");

  const _component_van_cell_group = _resolveComponent("van-cell-group");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_cell_group, {
    inset: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("text", null, _toDisplayString(_ctx.data.balance), 1), _hoisted_3])]), _createVNode(_component_van_button, {
      round: "",
      block: "",
      type: "primary",
      disabled: !_ctx.isComplete || _ctx.data.balance == 0,
      onClick: _ctx.onWithdraws
    }, {
      default: _withCtx(() => [_hoisted_4]),
      _: 1
    }, 8, ["disabled", "onClick"]), _ctx.data.show_trans ? (_openBlock(), _createBlock(_component_van_button, {
      key: 0,
      round: "",
      block: "",
      plain: "",
      hairline: "",
      type: "primary",
      style: {
        "margin-top": "15px"
      },
      onClick: _ctx.onTransDetail
    }, {
      default: _withCtx(() => [_hoisted_5]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true), _ctx.data.cs_tel != null ? (_openBlock(), _createBlock(_component_van_button, {
      key: 1,
      round: "",
      block: "",
      plain: "",
      hairline: "",
      type: "primary",
      onClick: _ctx.onCallCS,
      style: {
        "margin-top": "15px"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(" 客服电话" + _toDisplayString(_ctx.data.cs_tel), 1)]),
      _: 1
    }, 8, ["onClick"])) : _createCommentVNode("", true)]),
    _: 1
  })]);
}